
















import { Prop, Vue, Component } from "vue-property-decorator";
@Component({

})
export default class ActionButton extends Vue {
  // tslint:disable-next-line:ban-types
  @Prop(Boolean) public disabled: boolean | undefined;
  @Prop(String) public text: string | undefined;
  @Prop(Boolean) public submitting?: boolean;
  private continueBtn() {
    this.$emit("click");
  }
  get btnText() {
    if (this.submitting) return "";
    if (this.text) { return this.text; } else { return this.$i18n.t("continue", this.$i18n.locale); }
  }
}
